/**
 * Layout spacing tokens. Use for consistent gaps (e.g. header-to-content).
 */
export const spacing = {
  /** Gap between header row (title + icon) and page content below. */
  headerContentGap: 16,
  /** Vertical gap between content blocks (e.g. between sections, after buttons/separators). */
  contentBlockGap: 24,
  /** Tight vertical gap (e.g. between Terms of Service and Privacy Policy links). */
  contentBlockGapTight: 8,
} as const
